import TagCommander from '@helpers/TagCommanders.class';

const tagCommanderInstance = TagCommander.getInstance();

tagCommanderInstance.run();

export {};
